import { Pipe, PipeTransform } from "@angular/core";
import { TagType, TagGroupType } from "src/enums/tagEnums";
import { ProductTagViewModel } from "src/domain/client";

@Pipe({
  name: "groupTags",
  pure: true,
})
export class GroupTagsPipe implements PipeTransform {
  transform(
    tags: ProductTagViewModel[] | undefined | null,
  ): Map<string, ProductTagViewModel[]> {
    const map = new Map<string, ProductTagViewModel[]>();

    const excludedGroups = [
      TagGroupType.Recommendations.toString(),
      TagGroupType.ProductFlagging.toString(),
      TagGroupType.ProductDescription.toString(),
      TagGroupType.Disclaimer.toString(),
      TagGroupType.AgreementText.toString(),
      TagGroupType.Rules.toString(),
    ];

    const excludedTagTypes = [
      TagType.IsWheel.toString(),
      TagType.IsVgsWheel.toString(),
      TagType.LinkEUlabelingTires.toString(),
    ];

    tags?.forEach((item) => {
      if (
        item.tag?.tagGroupType?.name &&
        !excludedGroups.includes(item.tag.tagGroupType.name) &&
        item.tag?.tagType?.name &&
        !excludedTagTypes.includes(item.tag.tagType.name)
      ) {
        const collection = map.get(item.tag.tagGroupType.name);

        if (!collection) {
          map.set(item.tag.tagGroupType.name, [item]);
        } else {
          collection.push(item);
        }
      }
    });
    return map;
  }
}
